import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/page-header";
import { Skeleton } from "@/components/ui/skeleton";
import { getProfile } from "@/lib/api/profile";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./page.i18n";
import { ProfileForm } from "./profile-form";

export default function ProfilePage() {
  const t = useT(T);

  const { data: user, isLoading } = useQuery({
    queryKey: ["profile"],
    queryFn: getProfile,
  });

  return (
    <div className="space-y-6">
      <PageHeader title={t.profile} description={t.managePersonalInfo} />

      {isLoading || !user ? (
        <div className="space-y-6">
          <Skeleton className="h-48 w-full" />
          <Skeleton className="h-96 w-full" />
          <Skeleton className="h-48 w-full" />
        </div>
      ) : (
        <ProfileForm user={user} />
      )}
    </div>
  );
}
